/* eslint-disable max-len */
export default {
  en: {
    file_show: 'View the file',
    file_show_click: 'To view this file, click',
    commit_diff_big:
      'TThe dif of this source code is very large to display it here. You can read it ',
    binary_file: 'Binary file. You can | download this file | to learn more about it',
    discussion_no: 'There are no discussions',
    create_merge_request: 'Create merge request',
    select_branch: 'Select a branch',
    choose_project: 'Choose project',
    project_website: 'Project website',
    language: 'Programming language | Select a programming language',
    history: 'History',
    project_choose: 'project',
    webhook_secret: 'Secret',
    select_tag: 'Select a tag',
    project_describe: 'Describe the project',
    tag_release_sort_time: 'By time',
    tag_release_sort_name: 'By name',
    tag_release_sort_time_desc: 'New ones first',
    tag_release_sort_time_asc: 'Old ones first',
    tag_release_sort_name_desc: 'From A to Z',
    tag_release_sort_name_asc: 'From Z to A',
    tag_release_sort_criteria_placeholder: 'Select sort criteria',
    tag_release_sort_direction_placeholder: 'Select sort direction',
    file_locked_by: 'Locked by',
    translitor_title: 'Reset to default alias'
  },
  ru: {
    file_show: 'Посмотреть файл',
    file_show_click: 'Чтобы просмотреть этот файл, нажмите',
    commit_diff_big:
      'Диф данного исходного кода очень большой чтобы отобразить его здесь. Вы можете ознакомится с ним ',
    binary_file: 'Бинарный файл. Вы можете | скачать этот файл |чтобы ознакомится с ним',
    discussion_no: 'Нет дискуссий',
    create_merge_request: 'Создать запрос',
    select_branch: 'Выберите ветку',
    choose_project: 'Выберите проект',
    project_website: 'Сайт проекта',
    language: 'Язык программирования | Выберите язык программирования',
    history: 'История',
    project_choose: 'проекта',
    webhook_secret: 'Секрет',
    select_tag: 'Выберите тег',
    project_describe: 'Опишите проект',
    tag_release_sort_time: 'По времени',
    tag_release_sort_name: 'По названию',
    tag_release_sort_time_desc: 'Сначала новые',
    tag_release_sort_time_asc: 'Сначала старые',
    tag_release_sort_name_desc: 'От А до Я',
    tag_release_sort_name_asc: 'От Я до А',
    tag_release_sort_criteria_placeholder: 'Выберите критерий сортировки',
    tag_release_sort_direction_placeholder: 'Выберите направление сортировки',
    file_locked_by: 'Заблокирован пользователем',
    translitor_title: 'Сброс до стандартного алиаса'
    
  }
};
